export default {
    // API_ENDPOINT: 'http://localhost:8000/api',
    API_ENDPOINT: 'https://fierce-harbor-75048.herokuapp.com/api',
    TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'climbr-token-key'
}